import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import './Home.css'

function Home() {
    const centerAlignment = "justify-content-md-center"

    return (
        // use this way to override the css: style={{ height: '1000px', border: '1px red solid' }}
        <Container fluid >
            <Row className={centerAlignment}>
                <Col md="8" lg="7">
                    {/* https://www.computerhope.com/issues/ch001662.htm */}
                    <h3 className='title'>About Me</h3>
                    <img src="profile.jpg" className='profile' alt="Zac's profile photo"></img>
                    <p>
                    My name is Zac, and I am a passionate software engineer with over 10 years of experience in Python for data processing. My career includes 7 years in software engineering roles, where I specialize in delivering enterprise solutions and driving data-driven decision-making, with a background in the geospatial domain.
                    </p>
                    <p>
                    As a full-stack developer, I am proficient in a wide range of programming languages and technologies, including Python, 
                    JavaScript, SQL, Terraform, and Java. My expertise spans ETL processes, big data analytics, database design, and data warehousing. 
                    I am also proud to hold multiple AWS and Databricks certifications at both Professional and Associate levels, 
                    showcasing my commitment to cloud computing and data engineering excellence.
                    </p>
                    <p>
                    Additionally, I have developed a project that allows users to view monthly average temperature data globally on a web map. If you're curious, feel free to explore it at <a href="https://map.global-temperature.com" target="_blank" rel="noopener noreferrer">map.global-temperature.com</a>.
                    </p>

                    <h4>Stacks</h4>
                    <ul >
                        <li className='tool-set'>Programming languages: Python, SQL, JavaScript/TypeScript, Java, Scala</li>
                        <li className='tool-set'>Big Data: Databricks, PySpark (structured streaming), Kafka, Kinesis</li>
                        <li className='tool-set'>Cloud: AWS, Terraform, CloudFormation, Serverless framework</li>
                        <li className='tool-set'>Backend & API: RESTful API, GraphQL & AWS AppSync, AWS Cognito, Flask</li>
                        <li className='tool-set'>Database: PostgreSQL(PL/pgSQL), SQL Server, DynamoDB, Redshift</li>
                        <li className='tool-set'>Web: React, Angular, Leaflet, OpenLayers, Mapbox</li>
                        <li className='tool-set'>DevOps: Git, GitHub, Jenkins, CodeBuild/CodePipeline</li>
                        <li className='tool-set'>GIS: QGIS, ESRI(ArcGIS), Geocortex</li>
                    </ul>

                    <h4>Certifications</h4>
                    <ul >
                        <li className='tool-set'>AWS Certified Solutions Architect Professional</li>
                        <li className='tool-set'>AWS Certified DevOps Engineer Professional</li>
                        <li className='tool-set'>AWS Certified Data Analytics Specialty</li>
                        <li className='tool-set'>AWS Certified Solutions Architect Associate</li>
                        <li className='tool-set'>Databricks Certified Data Engineer Professional</li>
                        <li className='tool-set'>Databricks Certified Data Engineer Associate</li>
                        <li className='tool-set'>Databricks Certified Associate Developer for Apache Spark</li>
                    </ul>
                    <h4 className='heading3-main-page'>Contact</h4>
                    <p>
                        Feel free to contact me via <a href="mailto:zacwang15@gmail.com">Email</a> or
                        <a href="https://www.linkedin.com/in/zac-wang"> LinkedIn</a>.
                    </p>
                </Col>
            </Row>
        </Container >
    )
}

export default Home;